import { ReviewAmenityAvailability } from '@/src/types/hotels/srp'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

/** Display name for each SRP amenity, shared by the filters and the result cards. */
export const useAmenityLabels = (): Record<keyof ReviewAmenityAvailability, string> => {
    const t = useTranslations('hotels')
    return useMemo(
        () => ({
            wifi: t('amenityWifi'),
            parking: t('amenityParking'),
            swim: t('amenitySwim'),
            gym: t('amenityGym'),
            roomService: t('amenityRoomService'),
            bar: t('amenityBar')
        }),
        [t]
    )
}
